<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Rate saved</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit charge rate</h1>
    <div class="alert alert-warning">
      Editing changes what this rate has always been, including on months already invoiced. To put
      a price <em>up</em>, add a new rate with a later start date instead.
    </div>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-storage-rate-form [rate]='this.rate'></app-storage-rate-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/warehousing/storage-rates'>Cancel</button>
    </form>
  </div>
</div>
